export const SET_SELECTED_SUITES = 'SET_SELECTED_SUITES'
export const CLEAR_SELECTED_SUITES = 'CLEAR_SELECTED_SUITES'
